/* most-popular.js — coverflow de la sección Most Popular (máster v2 776:5159).

   El script solo mantiene una cosa: `--d`, la distancia CIRCULAR de cada slide
   al activo (0 = centro, -1 = izquierda, 1 = derecha, |d|>=2 = fuera). Toda la
   geometría (±92.99% del ancho del slide, scale 0.773, máscaras) vive en el
   CSS, así que sin JS el slide 0 queda centrado con sus vecinas y la sección se
   ve como el fotograma del máster.

   Se carga UNA sola vez desde theme.liquid, igual que carousel.js: el IIFE
   recorre todos los [data-mp-carousel] del documento y no es idempotente. */
(function () {
  /* Rotador de testimonios del head (25-ago): uno visible a la vez, crossfade
     cada 5s (el CSS pone la transicion; aqui solo se mueve .is-active). Se
     para con prefers-reduced-motion, con el puntero encima o el foco dentro
     (para no arrancarle a nadie la cita que esta leyendo), y cuando el bloque
     no esta en pantalla. Sin JS queda el primero, estatico. */
  document.querySelectorAll('[data-mp-quotes]').forEach(function (wrap) {
    var quotes = Array.prototype.slice.call(wrap.querySelectorAll('[data-mp-quote]'));
    if (quotes.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var current = 0;
    var paused = false;
    var onScreen = true;

    ['pointerenter', 'focusin'].forEach(function (evt) {
      wrap.addEventListener(evt, function () { paused = true; });
    });
    ['pointerleave', 'focusout'].forEach(function (evt) {
      wrap.addEventListener(evt, function () { paused = false; });
    });
    if (typeof IntersectionObserver === 'function') {
      new IntersectionObserver(function (entries) {
        onScreen = entries[0].isIntersecting;
      }, { threshold: 0.3 }).observe(wrap);
    }

    setInterval(function () {
      if (paused || !onScreen) return;
      quotes[current].classList.remove('is-active');
      current = (current + 1) % quotes.length;
      quotes[current].classList.add('is-active');
    }, 5000);
  });

  var roots = document.querySelectorAll('[data-mp-carousel]');
  if (!roots.length) return;

  Array.prototype.forEach.call(roots, function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-mp-slide]'));
    var total = slides.length;
    if (total < 2) return;

    var prev = root.querySelector('[data-mp-prev]');
    var next = root.querySelector('[data-mp-next]');
    var current = 0;

    function render() {
      slides.forEach(function (slide, index) {
        var d = index - current;
        /* Distancia circular: con 4 slides, el último a la izquierda del
           primero es -1, no 3. Así el carrusel da la vuelta y siempre hay
           vecina a los dos lados. */
        if (d > total / 2) d -= total;
        if (d < -total / 2) d += total;
        slide.style.setProperty('--d', d);
        slide.classList.toggle('is-current', d === 0);
        slide.classList.toggle('is-prev', d === -1);
        slide.classList.toggle('is-next', d === 1);
      });
    }

    function go(step) {
      current = (current + step + total) % total;
      render();
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        go(-1);
        e.preventDefault();
      } else if (e.key === 'ArrowRight') {
        go(1);
        e.preventDefault();
      }
    });

    /* Marca de mejora progresiva: las flechas están ocultas por CSS hasta acá,
       para no dejar botones que no hacen nada si el JS no llegó a correr. */
    root.classList.add('is-enhanced');
    render();
  });
})();
